import { TemplateItemAggregate } from './templateItemModel';
import { TemplateItemProps } from './templateItemProps';

export function buildTemplateItemProps(
    aggregate: TemplateItemAggregate
): TemplateItemProps {
    return {
        id: aggregate.tool.id,
        label: aggregate.tool.name,
        description: aggregate.tool.description,
        caption: aggregate.tool.tagline,
        author: aggregate.definition.display_name,
        icon: {
            kind: 'emoji',
            value: aggregate.tool.icon || '🔧',
        },
    };
}

/**
 * Factory function to convert a TemplateItemAggregate to TemplateItemProps
 * with navigation functionality
 */
export function buildTemplateItemPropsWithNavigation(
    aggregate: TemplateItemAggregate,
    navigate: (path: string | null, replace?: boolean) => void
): TemplateItemProps {
    return {
        id: aggregate.tool.id,
        label: aggregate.tool.name,
        description: aggregate.tool.description,
        caption: aggregate.tool.tagline,
        author: aggregate.definition.display_name,
        icon: {
            kind: 'emoji',
            value: aggregate.tool.icon || '🔧',
        },
        onClick: () => {
            navigate(`template/${aggregate.tool.id}`);
        },
    };
}
